import React from 'react';
import { Select } from '../ui-kit';
import lodash from 'lodash';

const customStyles = {
  menuList: base => ({
    ...base,
    height: 120
  })
};

const RankSelector = ({ selectedRank, ranks, inputName, handleChange }) => {
  const options = lodash.sortBy(Object.values(ranks), ['order']).map(r => {
    const textLabel = r.name;
    const label = (
      <div style={{ maxHeight: '40px', overflow: 'hidden', whiteSpace: 'nowrap' }}>
        <div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
          <span>{textLabel}</span>
        </div>
      </div>
    );
    return { value: r.id, textLabel, label };
  });

  const selectedOption = options.find(o => o.value == selectedRank);

  const filterOption = (op, filterValue) => op.data.textLabel.toLowerCase().includes(filterValue.toLowerCase());

  return (
    <Select
      styles={customStyles}
      name={inputName}
      value={selectedOption}
      onChange={handleChange}
      options={options}
      isMulti={false}
      isClearable={false}
      isSearchable={true}
      className="react-select"
      placeholder={I18n.t('none')}
      filterOption={filterOption}
    />
  );
};

export default RankSelector;
